module.exports = __webpack_public_path__ + "static/media/volume-1.d67ccd65.svg";